import { render, staticRenderFns } from "./ClockView.vue?vue&type=template&id=67d1c924&scoped=true&"
import script from "./ClockView.vue?vue&type=script&lang=js&"
export * from "./ClockView.vue?vue&type=script&lang=js&"
import style0 from "./ClockView.vue?vue&type=style&index=0&id=67d1c924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1c924",
  null
  
)

export default component.exports